//IMPORTAÇÕES
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js';
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import { revelarEditarElemento, revelarNovoElemento } from '../../../redux/actions';
import { elipseVerde, exclamacao, fecharJanela, setaDropdown } from '../../../utils/alternanciaIcones';
import MensagemErro from '../../componentesModais/mensagens/mensagemErro';
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso';
import SelectTela from '../../componentesModais/selects/selectTela';

import '../../../css/painelAdministrativo/pavElemento/pavElemento.css';

export default function CadastroElemento(props) {
    //SPINNER
    const [spinAtivo, setSpinAtivo] = useState(true);
    //HOOKS VALIDAÇÂO
    const { register, handleSubmit, errors } = useForm();/*eslint-disable*/
    //HOOKS PRINCIPAIS
    const [cdElemento, setCdElemento] = useState(0);
    const [cdTela, setCdTela] = useState(-1);
    const [dsTela, setDsTela] = useState('Selecione');
    const [dsRota, setDsRota] = useState('');
    const [dsNome, setDsNome] = useState('');
    const [dsDescricao, setDsDescricao] = useState('');
    //HOOKS PLACEHOLDERS
    const [phTela, setPhTela] = useState('');
    const [phRota, setPhRota] = useState('');
    const [phNome, setPhNome] = useState('');
    const [phDescricao, setPhDescricao] = useState('');
    const [phMensagemSucesso, setPhMensagemSucesso] = useState('cadastrado')
    //HOOKS MODAIS
    const [revelarSelectTela, setRevelarSelectTela] = useState(false)
    const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
    const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
    //OUTROS HOOKS
    const [tituloJanela, setTituloJanela] = useState('Cadastro');
    const [caracteresMensagem, setCaracteresMensagem] = useState(500);
    const [mensagemErro, setMensagemErro] = useState("Ocorreu um erro ao executar esta ação");
    const modal = useRef();
    const despacho = useDispatch();

    const iconeAlerta = <img className="icone-alerta" src={exclamacao()} alt='exclamacao'/>;

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };
    
    useEffect(() => {
        setSpinAtivo(true)
        if (props.tituloJanela === 'Editar'){
            //TROCA O TITULO DA JANELA
            setTituloJanela('Editar')
            //CARREGA OS CAMPOS COM OS VALORES ORIGINAIS
            setCdElemento(props.cdElemento);
            setCdTela(props.cdTela);
            setDsTela(props.dsTela);
            setDsRota(props.dsRota);
            setDsNome(props.dsNome);
            setDsDescricao(props.dsDescricao);
            //CARREGA OS PLACEHOLDERS COM VALORES ORIGINAIS
            setPhTela('Original: '+props.dsTela);
            setPhRota('Original: /'+props.dsRota);
            setPhNome('Original: '+props.dsNome);
            setPhDescricao('Original: '+props.dsDescricao);
            setPhMensagemSucesso('editado')
        }
        if (props.tituloJanela === 'Cadastrar'){
            setTituloJanela('Cadastrar')
            //CARREGA OS PLACEHOLDERS COM VALORES ORIGINAIS
            setPhTela('Selecione');
            setPhRota('/rota');
            setPhNome('Nome');
            setPhDescricao('Descrição');
            setPhMensagemSucesso('cadastrado')
        }
        document.addEventListener('mousedown', handleClickFora);
        setSpinAtivo(false)
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])//eslint-disable

    //FAZ O MANEJO 
    function handleSalvar(){
        if (tituloJanela === 'Cadastrar'){
            ColetaClickstream(1323) // 'pavElementoTabelaGridNovoElementoCadastrar
            handleCadastrar()
        }else{
            ColetaClickstream(1324) // 'pavElementoTabelaGridNovoElementoEditar
            handleAlterar()
        }
    }

    async function handleAlterar(){
        setSpinAtivo(true)
        await api_gateway.post('/m1/alterar/elemento', {
            "dados":{
                'cd_pav_tela' : cdTela,
                'ds_rota' : dsRota.trim(),
                'ds_pav_elemento' : dsNome.trim(),
                'ds_descricao' : dsDescricao.trim()
                },
            "condicao":{
                'cd_pav_elemento' : cdElemento,	
               }
        })
        .then(function (response) {
            setRevelarMensagemSucesso(true)
            setSpinAtivo(false)
        })
        .catch(function (error) {
            setMensagemErro(error.response.data.info)
            setRevelarMensagemErro(true)
            setSpinAtivo(false)
        });
    }

    async function handleCadastrar(){
        setSpinAtivo(true)
        await api_gateway.post('/m1/cadastrar/elemento', {
            'cd_pav_tela' : cdTela,
            'ds_rota' : dsRota.trim(),
            'ds_pav_elemento' : dsNome.trim(),
            'ds_descricao' : dsDescricao.trim()
        },)
        .then(function (response) {
            setRevelarMensagemSucesso(true)
            setSpinAtivo(false)
        })
        .catch(function (error) {
            setMensagemErro(error.response.data.info)
            setRevelarMensagemErro(true)
            setSpinAtivo(false)
        });
    }

    function handleCancelar(){
        ColetaClickstream(1322) // 'pavElementoTabelaGridNovoElementoCancelar
        despacho(revelarNovoElemento(false))
        despacho(revelarEditarElemento(false))
        setRevelarMensagemSucesso(false)
        setRevelarMensagemErro(false)
        props.setRenderizar(!props.renderizar)
        props.setRevelarCadastro(false)
        props.setRevelarEdicao(false)
    }
    

    function handleDescricao(valor){
        setDsDescricao(valor)
        setCaracteresMensagem(500 - valor.length)
    }

    function handleMensagemErro(confirmacao){
        if(revelarMensagemErro === false){
            setRevelarMensagemErro(true)
        }else{
            setRevelarMensagemErro(false)
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }
    
    function handleMensagemSucesso(confirmacao){
        if(revelarMensagemSucesso === false){
            setRevelarMensagemSucesso(true)
        }else{
            setRevelarMensagemSucesso(false)
            if(confirmacao === true){
                handleCancelar()
            }
            handleCancelar()
        }
    }

    return(
        <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <div className="modal-cadastro-elemento fundo-cor-6">
                <Form.Row>
                    <Col>
                        <img className="icone-label-janela nao-selecionavel" src={elipseVerde()} alt="elipse"/>
                        <Form.Label>
                            <div className="fonte-cor-1 label-janela">{tituloJanela} elemento</div>
                        </Form.Label>
                        <Button className="botao-fechar-janela" variant="danger" onClick={() => handleCancelar()}>
                            <img className="botao-fechar-janela-icone" src={fecharJanela()} alt="fechar-janela"/>
                        </Button>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <div className="grupo-cadastro-elemento-1">
                            <div className="coluna-cadastro-elemento-1">
                                <Form.Group>
                                    <Form.Label>
                                        <div className="fonte-cor-1 label-campo label-campo">Tela</div>
                                    </Form.Label>
                                    { revelarSelectTela === false &&
                                        <Button name="cdTela" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectTela(!revelarSelectTela)}>
                                            <div className="fonte-cor-1 label-campo label-campo">{dsTela}</div>
                                            <img className={revelarSelectTela?"campo-select-icone-ativado nao-selecionavel":"campo-select-icone-desativado nao-selecionavel"} src={setaDropdown()} alt="drop" />
                                        </Button>
                                    }
                                    { revelarSelectTela === true &&
                                        <SelectTela
                                            setRevelarSelectTela={setRevelarSelectTela} //Hook para fechar a modal
                                            setCdTela={setCdTela} //Código do Tela
                                            setDsTela={setDsTela} //Nome do Tela
                                            dsTela={dsTela} 
                                            phTela={phTela} //Placeholder para mostrar o valor original em caso de edição
                                        >
                                        </SelectTela>
                                    }
                                </Form.Group>
                            </div>
                            <div className="coluna-cadastro-elemento-2">
                                <Form.Group>
                                    <Form.Label>
                                        <div className="fonte-cor-1 label-campo">Rota</div>
                                    </Form.Label>
                                    <OverlayTrigger  delay={{ show: 500, hide: 250 }} placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}>Rota</Tooltip>}>
                                        <Form.Control name="dsRota" value={dsRota}  className="campo-texto-cor-3 campo-texto" type="text" maxlength="25" placeholder={phRota} onChange={e => setDsRota(e.target.value)} 
                                        ref={register({validate: {minimo: value => value.length > 1}})}/>
                                    </OverlayTrigger>
                                    {errors.dsRota && <p className="fonte-cor-3 label-alerta">{iconeAlerta} O campo é obrigatorio.</p>}
                                </Form.Group>
                            </div>
                        </div>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>
                                <div className="fonte-cor-1 label-campo">Nome</div>
                            </Form.Label>
                            <OverlayTrigger  delay={{ show: 500, hide: 250 }} placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}>Nome</Tooltip>}>
                                <Form.Control name="dsNome" value={dsNome}  className="campo-texto-cor-3 campo-texto" type="text" placeholder={phNome} onChange={e => setDsNome(e.target.value)} 
                                ref={register({validate: {minimo: value => value.length > 1}})} maxlength="100"/>
                            </OverlayTrigger>
                            {errors.dsNome && <p className="fonte-cor-3 label-alerta">{iconeAlerta} O campo é obrigatorio.</p>}
                        </Form.Group>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>
                                <div className="fonte-cor-1 label-campo">Descrição</div>
                            </Form.Label>
                            <OverlayTrigger  delay={{ show: 500, hide: 250 }} placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}>Descrição</Tooltip>}>
                                <Form.Control className="campo-texto-cor-3 campo-texto-area" as="textarea" rows="3" maxlength="500" placeholder={phDescricao} defaultValue={dsDescricao} onChange={e => handleDescricao(e.target.value)}></Form.Control>
                            </OverlayTrigger>
                            <Form.Label className="contador-carateres-restantes">
                                <div className="fonte-cor-1 label-normal">{caracteresMensagem} caracteres restantes</div>
                            </Form.Label>
                        </Form.Group>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <Button  type="submit" className="botao-confirmar" variant="success" size="sm">
                            <div className="fonte-cor-4">{tituloJanela}</div>
                        </Button>
                        <Button className="botao-cancelar" variant="success" size="sm" onClick={() => handleCancelar()}>
                            <div className="fonte-cor-2">Cancelar</div>
                        </Button>
                    </Col>
                </Form.Row>
            </div>
            { revelarMensagemSucesso &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemSucesso
                            handleMensagemSucesso={handleMensagemSucesso}
                            mensagemTitulo={"Sucesso"}
                            mensagemParagrafo1={"Elemento "+dsNome+" "+phMensagemSucesso+"."}
                            mensagemBotao={"Continuar"}
                        />
                    </div>
                </div>
            }
            { revelarMensagemErro &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemErro
                            handleMensagemErro={handleMensagemErro}
                            mensagemTitulo={"Erro!"}
                            mensagemParagrafo1={mensagemErro}
                            mensagemBotao={"Retornar"}
                        />
                    </div>
                </div>
            }
        </Form>
    )
}